<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Consider an aqueous solution of
        <chemical-latex content="NaHSO3" />
      </p>

      <!-- TODO: What do we want to do with a-c? -->
      <p class="mb-2">(a) Write down the charge balance equation of the solution.</p>
      <p class="mb-2">(b) Write down the mass balance equation of the solution.</p>
      <p class="mb-2">
        (c) Starting with the expressions in (a) and (b), derive an expression for
        <chemical-latex content="[H3O+]." />
      </p>

      <p class="mb-2">
        (d) Calculate the
        <stemble-latex content="$\text{pH}$" />
        of the
        <chemical-latex content="NaHSO3" />
        solution, if its molarity is
        <number-value :value="molarity" unit="\text{M}" />
      </p>

      <calculation-input
        v-model="inputs.input1"
        class="mb-5"
        prepend-text="$\text{pH}:$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';
import NumberValue from '../NumberValue';

export default {
  name: 'ChemUPEI2210A6Q4',
  components: {
    ChemicalLatex,
    CalculationInput,
    StembleLatex,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
    };
  },
  computed: {
    molarity() {
      return this.taskState.getValueBySymbol('molarity').content;
    },
  },
};
</script>
